const angular = require('angular')

module.exports = angular
  .module('mw.shared', [
    require('./step-indicator.directive'),
    require('./sub-menu.directive'),
    require('./util.directive'),
    require('./auto-focus.directive'),
  ]).name
